export enum ExportType {
  CSV = "CSV",
  JSON = "JSON",
  JSON_CUSTOM = "JSON custom format",
  XML = "XML",
}
